function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import LocaleKeys from '../../../../locales/keys';
import { REPORTING_LEVELS } from '../../../customer/accountHierarchy/account.hierarchy.constants';
var MoveHierarchyNodeController = /*#__PURE__*/function () {
  function MoveHierarchyNodeController($timeout) {
    _classCallCheck(this, MoveHierarchyNodeController);
    Object.assign(this, {
      LocaleKeys: LocaleKeys,
      $timeout: $timeout,
      labelText: i18n.translate(LocaleKeys.ACCOUNT_HIERARCHY.SELECT_THE_NEW_PARENT_FOR),
      nodeBillingTypeIconGlyph: this.nodeBillingTypeIconGlyph.bind(this),
      nodeBillingTypeLabel: this.nodeBillingTypeLabel.bind(this),
      onConfirm: this.onConfirm.bind(this),
      onClose: this.onClose.bind(this)
    });
  }
  return _createClass(MoveHierarchyNodeController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.newParentNode.currentValue) {
        this.labelText = "".concat(this.newParentNode.NodeName, " ").concat(i18n.translate(LocaleKeys.ACCOUNT_HIERARCHY.WILL_BE_THE_NEW_PARENT_FOR));
      }
    }
  }, {
    key: "nodeBillingTypeIconGlyph",
    value: function nodeBillingTypeIconGlyph() {
      var billingTypeIconGlyph = 'dollar-circle';
      if (this.nodeToMove.ReportingLevel === REPORTING_LEVELS.REPORTING_LEVEL_STATEMENT || this.nodeToMove.ReportingLevel === REPORTING_LEVELS.REPORTING_LEVEL_NONE) {
        billingTypeIconGlyph = 'filled-circled-up-arrow';
      }
      return billingTypeIconGlyph;
    }
  }, {
    key: "nodeBillingTypeLabel",
    value: function nodeBillingTypeLabel() {
      var billingTypeLocaleKey = LocaleKeys.BILLING;
      var billingTypeLocaleParameters = {};
      if (this.nodeToMove.ReportingLevel === REPORTING_LEVELS.REPORTING_LEVEL_STATEMENT || this.nodeToMove.ReportingLevel === REPORTING_LEVELS.REPORTING_LEVEL_NONE) {
        billingTypeLocaleKey = LocaleKeys.PASS_THROUGH_BILLING;
        // pass-through billing nodes pass-through to their parent
        billingTypeLocaleParameters = {
          receiver: "".concat(this.nodeToMove.ParentSubscriber.FirstName, " ").concat(this.nodeToMove.ParentSubscriber.LastName)
        };
      }
      return i18n.translate(billingTypeLocaleKey, billingTypeLocaleParameters);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.closeContainer()();
    }
  }, {
    key: "onConfirm",
    value: function onConfirm() {
      this.nodeToMove.ParentSubscriberId = this.newParentNode.SubscriberId;
      this.onConfirmation()(this.nodeToMove);
    }
  }]);
}();
export default {
  template: require('./move.hierarchy.node.template.html'),
  controller: MoveHierarchyNodeController,
  controllerAs: 'MoveHierarchyNodeController',
  bindings: {
    nodeToMove: '<',
    newParentNode: '<?',
    closeContainer: '&',
    onConfirmation: '&'
  }
};